import { RoleDomainModel } from '@shared/models/backend'
import { getRole } from '@shared/utils/degts-utils'

export interface SideMenuItemConfig {
  title: string
  icon: string // material icon name
  to?: string
  roles: RoleDomainModel[]
  isRotaResidenteInativo?: boolean
  children?: SideMenuSubItem[]
}

export type SideMenuSubItem = Pick<SideMenuItemConfig, 'title' | 'to' | 'roles' | 'isRotaResidenteInativo'>

export const SIDE_MENU_ITEMS: SideMenuItemConfig[] = [
  {
    title: 'Inscrições',
    icon: 'assignment',
    to: '/edital/inscricoes',
    roles: [getRole('ROLE_COORDENADOR')],
  },
  {
    title: 'Editais',
    icon: 'assignment',
    to: '/edital/listagem',
    roles: [getRole('ROLE_DEGTS'), getRole('ROLE_ADMINISTRADOR')],
  },

  {
    title: 'Dados da comissão',
    icon: 'account_balance',
    to: '/comissao',
    roles: [getRole('ROLE_COORDENADOR')], //, getRole('ROLE_ADMINISTRADOR')],
  },
  {
    title: 'Avaliação de inscrições',
    icon: 'grading',
    to: '/avaliacoes',
    roles: [getRole('ROLE_DEGTS'), getRole('ROLE_ADMINISTRADOR')],
  },
  {
    title: 'Programas de residência',
    icon: 'library_books',
    to: '/programas/coordenacao',
    roles: [getRole('ROLE_COORDENADOR')], // , getRole('ROLE_ADMINISTRADOR')],
  },
  {
    title: 'Programa de residência',
    icon: 'library_books',
    to: '/programas/{programaId}',
    roles: [getRole('ROLE_SUPERVISOR')],
  },
  {
    title: 'Programas de residência',
    icon: 'library_books',
    roles: [getRole('ROLE_DEGTS'), getRole('ROLE_ADMINISTRADOR')],
    children: [
      {
        title: 'Área profissional da saúde',
        to: '/programas/degts/multi',
        roles: [getRole('ROLE_DEGTS'), getRole('ROLE_ADMINISTRADOR')],
      },
      {
        title: 'Médica',
        to: '/programas/degts/medica',
        roles: [getRole('ROLE_DEGTS'), getRole('ROLE_ADMINISTRADOR')],
      },
    ],
  },
  {
    title: 'Instituições',
    icon: 'account_balance_filled',
    to: '/instituicao',
    roles: [getRole('ROLE_DEGTS'), getRole('ROLE_ADMINISTRADOR')],
  },
  {
    title: 'Residentes',
    icon: 'people_filled',
    roles: [getRole('ROLE_DEGTS'), getRole('ROLE_ADMINISTRADOR')],
    children: [
      {
        title: 'Área profissional da saúde',
        to: '/residente/degts/multi',
        roles: [getRole('ROLE_DEGTS'), getRole('ROLE_ADMINISTRADOR')],
      },
      {
        title: 'Médica',
        to: '/residente/degts/medica',
        roles: [getRole('ROLE_DEGTS'), getRole('ROLE_ADMINISTRADOR')],
      },
      {
        title: 'Residências concluídas em lotes',
        to: '/residente/listagem-concluidas-em-lotes',
        roles: [getRole('ROLE_DEGTS'), getRole('ROLE_ADMINISTRADOR')],
      },
    ],
  },
  {
    title: 'Residentes',
    icon: 'people_filled',
    roles: [getRole('ROLE_COORDENADOR'), getRole('ROLE_SUPERVISOR')],
    children: [
      {
        title: 'Listagem de residentes',
        to: '/residente/listagem-residentes',
        roles: [getRole('ROLE_COORDENADOR'), getRole('ROLE_SUPERVISOR'), getRole('ROLE_ADMINISTRADOR')],
      },
      {
        title: 'Conclusão de residência em lotes',
        to: '/residente/listagem-concluidas-em-lotes',
        roles: [getRole('ROLE_COORDENADOR'), getRole('ROLE_SUPERVISOR'), getRole('ROLE_ADMINISTRADOR')],
      },
    ],
  },
  // {
  //   title: 'Pagamentos',
  //   icon: 'local_atm',
  //   to: '/programas/pagamentos/coordenacao',
  //   roles: [getRole('ROLE_COORDENADOR')],
  // },
  // {
  //   title: 'Pagamentos',
  //   icon: 'local_atm',
  //   to: '/pagamento/programa/{programaId}',
  //   roles: [getRole('ROLE_SUPERVISOR')],
  // },
  {
    title: 'Dados do perfil',
    icon: 'person',
    to: '/residente/dados',
    roles: [getRole('ROLE_RESIDENTE') /* getRole('ROLE_ADMINISTRADOR')*/],
    isRotaResidenteInativo: true,
  },
  {
    title: 'Dados da matrícula',
    icon: 'badge',
    to: '/matricula/info',
    roles: [getRole('ROLE_RESIDENTE') /*, getRole('ROLE_ADMINISTRADOR')*/],
    isRotaResidenteInativo: true,
  },
  // {
  //   title: 'Pagamentos',
  //   icon: 'monetization_on',
  //   to: '/pagamentosResidente',
  //   roles: [getRole('ROLE_RESIDENTE')],
  // },
  // {
  //   title: 'Pagamentos',
  //   icon: 'local_atm',
  //   roles: [getRole('ROLE_DEGTS')],
  //   children: [
  //     {
  //       title: 'Área profissional da saúde',
  //       to: '/programas/pagamentos/degts/multi',
  //       roles: [getRole('ROLE_DEGTS')],
  //     },
  //     {
  //       title: 'Médica',
  //       to: '/programas/pagamentos/degts/medica',
  //       roles: [getRole('ROLE_DEGTS')],
  //     },
  //   ],
  // },
  // {
  //   title: 'Gerenciar pagamentos',
  //   icon: 'price_check',
  //   roles: [getRole('ROLE_FINANCEIRO')],
  //   children: [
  //     {
  //       title: 'Gerenciar competência',
  //       to: '/pagamento/gerenciar/competencias',
  //       roles: [getRole('ROLE_FINANCEIRO')],
  //     },
  //     {
  //       title: 'Valor da bolsa de residência',
  //       to: '/pagamento/gerenciar/valor-bolsa-residencia',
  //       roles: [getRole('ROLE_FINANCEIRO')],
  //     },
  //   ],
  // },
  // {
  //   title: 'Contestações',
  //   icon: 'feedback_filled',
  //   to: '/contestacoes/degts',
  //   roles: [getRole('ROLE_DEGTS')],
  // },
  // {
  //   title: 'Contestações',
  //   icon: 'feedback_filled',
  //   to: '/contestacoes/coordenador',
  //   roles: [getRole('ROLE_COORDENADOR')],
  // },
  // {
  //   title: 'Contestações',
  //   icon: 'feedback_filled',
  //   to: '/contestacoes/supervisor',
  //   roles: [getRole('ROLE_SUPERVISOR')],
  // },
  {
    title: 'Transferências',
    icon: 'swap_horizontal_circle',
    to: '/transferencia/coordenador',
    roles: [getRole('ROLE_COORDENADOR')],
  },
  {
    title: 'Transferências',
    icon: 'swap_horizontal_circle',
    to: '/transferencia/degts',
    roles: [getRole('ROLE_DEGTS'), getRole('ROLE_TRANSFERENCIA'), getRole('ROLE_ADMINISTRADOR')],
  },
  {
    title: 'Solicitação de Auxílio-Moradia',
    icon: 'home',
    to: '/auxilio-moradia/solicitacao',
    roles: [getRole('ROLE_RESIDENTE')],
  },
  {
    title: 'Concessão de Auxílio-Moradia',
    icon: 'home',
    to: '/auxilio-moradia/listagem',
    roles: [
      getRole('ROLE_DEGTS'),
      getRole('ROLE_ADMINISTRADOR'),
      getRole('ROLE_COORDENADOR'),
      getRole('ROLE_SUPERVISOR'),
    ],
  },
  {
    title: 'Relatórios',
    icon: 'assessment',
    to: '/relatorios',
    roles: [getRole('ROLE_DEGTS'), getRole('ROLE_ADMINISTRADOR')],
  },
  {
    title: 'Configurações',
    icon: 'settings',
    roles: [getRole('ROLE_DEGTS'), getRole('ROLE_ADMINISTRADOR')],
    children: [
      {
        title: 'Duração das Especialidades',
        to: '/configuracoes/formacao-duracao',
        roles: [getRole('ROLE_ADMINISTRADOR')],
      },
      {
        title: 'Tipos de programa',
        to: '/configuracoes/tipos-programa',
        roles: [getRole('ROLE_ADMINISTRADOR')],
      },
      {
        title: 'Remover acesso de coordenador de comissão',
        to: '/configuracoes/remover-coordenador',
        roles: [getRole('ROLE_ADMINISTRADOR')],
      },
      {
        title: 'Arquivos do rodapé',
        to: '/configuracoes/arquivos-rodape',
        roles: [getRole('ROLE_DEGTS'), getRole('ROLE_ADMINISTRADOR')],
      },
      {
        title: 'Termos de compromisso',
        to: '/configuracoes/arquivos-termo-compromisso',
        roles: [getRole('ROLE_DEGTS'), getRole('ROLE_ADMINISTRADOR')],
      },
    ],
  },
  {
    title: 'Developer menu',
    icon: 'settings',
    roles: [getRole('ROLE_DEV')],
    children: [
      {
        title: 'Manutenção',
        roles: [getRole('ROLE_DEV')],
        to: '/dev/manutencao',
      },
      {
        title: 'Informes de rendimento',
        roles: [getRole('ROLE_DEV')],
        to: '/dev/informe-rendimento',
      },
    ],
  },
]
